<template>
    <div class="">
        <GoogleMap
                v-bind="mapOptions"
                ref="gMap"
                :center="{lat:location.latitude, lng:location.longitude}"
                :zoom="location.zoom"
                :style="mapStyle"
        >
            <Marker :options="markerOptions"/>
        </GoogleMap>
    </div>
</template>

<script>
    import { Marker } from 'vue3-google-map';

    import GoogleMap from './maps/GoogleMap.vue';

    export default {
        name: "LocationWithMarker",
        components: { GoogleMap, Marker },
        props: {
            location: {
                type: Object,
                required: true
            }
        },
        computed: {
            // vue3-google-map has a prop per map option rather than one `options` object, so
            // these are spread onto the map with `v-bind` and land on its props from there
            mapOptions() {
                return {
                    zoomControl: true,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: true,
                    disableDefaultUi: false
                };
            },
            markerOptions() {
                return {
                    position: {lat: this.location.latitude, lng: this.location.longitude},
                    clickable: false,
                    draggable: false
                };
            },
            mapStyle() {
                // this.windowWidth
                return {
                    width: `100%`,
                    height: `300px`
                };
            },
        }
    };
</script>

<style scoped>

</style>
